// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zju-","controls":"styles_controls__1N-TW","charLimit":"styles_charLimit__3mZXQ","input":"styles_input__OXQxp","send":"styles_send__3maAh"};